import { jsx as o } from "react/jsx-runtime";
import { Separator as e } from "@base-ui/react/separator";
import { cn as i } from "../../lib/utils.js";
function n({
  className: a,
  orientation: r = "horizontal",
  ...t
}) {
  return /* @__PURE__ */ o(
    e,
    {
      "data-slot": "separator",
      orientation: r,
      className: i(
        "shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch",
        a
      ),
      ...t
    }
  );
}
export {
  n as Separator
};
//# sourceMappingURL=separator.js.map
